import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonNavigationModule } from '@common-modules/navigation/common-navigation.module';
import { HideNavbarsService } from '@common-modules/navigation/hide-navbars.service';
import { TranslateModule } from '@ngx-translate/core';
import { TreelistComponent } from '../shared/core/treelist/treelist.component';
import { WlmSharedModule } from '../shared/wlm-shared.module';
import { HomeConfigurationPopupComponent } from './home-configuration-popup/home-configuration-popup.component';
import { NotificationConfigurationPopupComponent } from './notification-configuration-page/notification-configuration-popup.component';
import { TopBarAccountCardComponent } from './top-bar-account-card/top-bar-account-card.component';
import { TopBarNotificationCreateButtonComponent } from './top-bar-notification-create-button/top-bar-notification-create-button.component';
import { TopBarNotificationUnreadButtonComponent } from './top-bar-notification-unread-button/top-bar-notification-unread-button.component';
import { TopBarComponent } from './top-bar/top-bar.component';
import { VersionInfoPopupComponent } from './version-info-popup/version-info-popup.component';

@NgModule({
  declarations: [
    TopBarComponent,
    TopBarAccountCardComponent,
    VersionInfoPopupComponent,
    TopBarNotificationCreateButtonComponent,
    TopBarNotificationUnreadButtonComponent,
    HomeConfigurationPopupComponent,
    NotificationConfigurationPopupComponent,
  ],
  exports: [TopBarComponent],
  imports: [
    CommonModule,
    WlmSharedModule,
    TranslateModule,
    TreelistComponent,
    CommonNavigationModule,
  ],
  providers: [HideNavbarsService, provideHttpClient(withInterceptorsFromDi())],
})
export class WlmNavigationModule {}
